<template>
  <div>
    <div>
      <div class="searchArea">

        <!-- <a-range-picker v-model:value="inputs.patroltime" :placeholder="['应巡开始时间','应巡结束时间']" :locale="locale" /> -->

        <a-input v-model:value="inputs.name" placeholder="患者名称" />
        <a-date-picker v-model:value="inputs.date" style="margin-right: 10px;" valueFormat="YYYY-MM-DD" placeholder="日期" />

        <a-button type="primary" shape="circle" @click="search('')">
          <template #icon>
            <SearchOutlined />
          </template>
        </a-button>
        <a-button style="margin-left: 10px" @click="resetForm">重置</a-button>
        <a-button style="margin-left: 10px" type="primary" @click="showModal()">
          <template #icon>
            <PlusOutlined />
          </template>
          新增预约
        </a-button>
      </div>
      <a-table class="ant-table-striped" :columns="columns" :data-source="data" :rowClassName="(record, index) => (index % 2 === 1 ? 'table-striped' : null)" bordered rowKey="id" :scroll="{ y: 550 }" :pagination="{ pageSize: 8, total, current }" @change="search">
        <template #operation="{ record }">
          <div class="flex_sa">
            <div class="editable-row-operations">
              <span v-if="record.tcmStatus == '看诊中'">
                <a @click="Detail(record)">继续看诊</a>
              </span>
              <span v-if="record.tcmStatus == '候诊中'">
                <a @click="Detail(record)">开始看诊</a>
              </span>
              <span v-if="record.tcmStatus == '已完成'">
                <a @click="Detail(record)">查看病例</a>
              </span>
              <span v-if="record.tcmStatus == '已过期'">
                <a style="color:#999">已过期</a>
              </span>
            </div>
            <div class="editable-row-operations" v-if="record.tcmStatus == '候诊中'">
              <span>
                <a-popconfirm title="是否确认删除" @confirm="handleDelete(record)" okText="确认" cancelText="取消">
                  <a>删除</a>
                </a-popconfirm>
              </span>
            </div>
          </div>

        </template>
        <template #assistantName="{ record,text ,col}">
          <div>
            <!-- <div>{{record.id}}</div> -->
            <!-- <a-input v-model:value="editableData[record.id][col]" /> -->
            <a-popconfirm v-if="editableData[record.id]" title="是否确认更改" @confirm="update(record)" okText="确认" cancelText="取消" :visible="showChange">
              <a-select v-model:value="editableData[record.id]['assistantName']" style="width:150px;text-align: center;" @change="showChange=true">
                <a-select-option v-for="item in option" :value="item.id">{{ item.name }}</a-select-option>
              </a-select>
            </a-popconfirm>
            <template v-else>{{ text }}
              <edit-outlined style="color:#40a9ff" @click="edit(record.id)" /></template>
          </div>
        </template>

      </a-table>

    </div>

    <addTodayConsultation v-model="visible" @reSearch="search('')" />

  </div>
</template>


<style scoped>
.ant-collapse {
  max-height: 72vh;
  overflow: auto;
}
</style>


<script>
import {
  SearchOutlined,
  PlusOutlined,
  DownloadOutlined,
  CheckCircleFilled,
  WarningFilled,
  FormOutlined,
  EditOutlined,
} from "@ant-design/icons-vue";
import { reactive } from "vue";
import { cloneDeep } from "lodash-es";
import locale from "ant-design-vue/es/date-picker/locale/zh_CN";
import { Search, Delete, SearchEmployee, Update } from "/src/api/todayConsultation.js";
import { pinyin } from 'pinyin-pro';
import getAutoPrescription from '/src/components/autoPrescription/getAutoPrescription.vue';
import addTodayConsultation from '/src/components/todayConsultation/addTodayConsultation.vue';

export default {
  components: {
    SearchOutlined,
    PlusOutlined,
    DownloadOutlined,
    locale,
    CheckCircleFilled,
    WarningFilled,
    getAutoPrescription,
    FormOutlined,
    addTodayConsultation,
    EditOutlined
  },
  name: "今日看诊",
  data() {
    return {
      visible: false,
      active: undefined,
      id: undefined,
      selectedRow: {},
      total: 0,
      current: 1,
      showChange:false,
      // pageSize: 10,
      inputs: {
        name: undefined,
        date: new Date().toLocaleDateString().split('/').join('-'),
      },
      modelInput: {
        name: undefined,
        gender: undefined,
        nameInitial: undefined,
        isStandard: true,
      },
      labelCol: {
        span: 6,
      },
      wrapperCol: {
        span: 14,
      },
      option: [],
      columns: [
        {
          title: "时间段",
          key: "period",
          dataIndex: "period",
          width: "20%",
          slots: {
            customRender: "period"
          }
        },
        {
          title: "患者",
          key: "customerName",
          dataIndex: "customerName",
          ellipsis: true,
          width: "20%",
          slots: {
            customRender: "customerName"
          },
        },
        {
          title: "电话",
          width: "20%",
          key: "gender",
          dataIndex: "gender",
          slots: {
            customRender: "gender"
          }
        },
        {
          title: "助理",
          key: "assistantName",
          dataIndex: "assistantName",
          // ellipsis: true,
          width: "20%",
          slots: {
            customRender: "assistantName"
          }
        },

        {
          title: "操作",
          dataIndex: "operation",
          width: "20%",
          slots: {
            customRender: "operation"
          }
        }
      ],
      data: [],
      rowSelection: {
        onChange: (selectedRowKeys, selectedRows) => {
          console.log(
            `selectedRowKeys: ${selectedRowKeys}`,
            "selectedRows: ",
            selectedRows
          );
          this.selectedRows = selectedRows;
        },
        onSelect: (record, selected, selectedRows) => {
          console.log(record, selected, selectedRows);
        },
        onSelectAll: (selected, selectedRows, changeRows) => {
          console.log(selected, selectedRows, changeRows);
        }
      },
      activeKey: ["看诊中"],
      editableData: reactive({}),
      selectedRows: {}
      // doExcel: doExcel
    };
  },
  created() { },
  mounted() {
    this.search("");
    this.searchEmployee()
  },
  activated() {
    if (localStorage.getItem("refrashProject") == "true") {
      // this.search(1);
    }
    localStorage.setItem("refrashProject", false);
  },
  methods: {

    showModal() {
      this.visible = true;
    },
    closeModal(value) {
      this[value] = false;
    },

    Detail(record) {
      this.visible4 = true
      this.selectedRow = { ...record }
    },
    async update(record) {
      console.log(this.editableData[record.id]);
      let data = this.editableData[record.id]

      let res = await Update({ id: data.id, assistantId: data.assistantName })
      if (res.errCode == 0) {
        this.editableData = []
        this.$message.success("修改成功", function () { });
        this.search("");
      }

    },
    async searchEmployee() {
      let res = await SearchEmployee({ position: "医生助理" })
      console.log(res);
      this.option = res.data.records

    },
    async handleOk() {
      let _this = this;

      let res = await Add(this.modelInput)
      if (res.errCode == 0) {
        _this.$message.success("新建成功", function () { });
        _this.visible = false
      }
    },
    async handleDelete(record) {
      let res = await Delete({ id: record.id })
      if (res.errCode == 0) {
        this.$message.success("删除成功", function () { });
        this.search("");
      }

    },
    resetForm() {
      this.inputs = {
        name: undefined,
        gender: undefined,
        isStandard: undefined,
      }
    },
    async addDisease() {
      this.visible = true;
    },
    async onDelete(id) {
      this.editableData = {}
      let res = await Delete({ id })
      this.data = this.data.filter(function (item) {
        return item.id !== id;
      });
    },
    edit(id) {
      let _data = this.data;

      this.editableData[id] = cloneDeep(
        _data.filter(item => id === item.id)[0]
      );
      console.log(this.editableData);
    },

    async save(id) {
      let _data = this.data;
      //判断editableData和修改前是否一致，如果一致则不修改
      if (JSON.stringify(this.data.find((item) => item.id == id)) === JSON.stringify(this.editableData[id])) {
        delete this.editableData[id];
        return;
      }
      let params = {
        id: this.editableData[id].id,
        name: this.editableData[id].name,
        nameInitial: this.editableData[id].nameInitial,
        gender: this.editableData[id].gender,
      }
      console.log(params);
      let res = await Update(params)
      if (res.errCode == 0) {
        Object.assign(
          _data.filter(item => id === item.id)[0],
          this.editableData[id]
        );
        delete this.editableData[id];
      }
    },
    cancel(id) {
      delete this.editableData[id];
    },

    async search(pagination) {
      let _this = this;
      this.editableData = {}
      let params = {
        name: this.inputs.name,
        date: this.inputs.date,
        pageSize: -1,
      };
      if (pagination == "") {
        params.current = 1
      } else {
        params.current = pagination.current
        this.current = pagination.current;
      }

      let res = await Search(params)
      if (res.errCode == 0) {
        if (pagination == "") {
          // this.$message.success("查询成功", function () { });
          this.current = 1;
        }
        this.total = res.data.total;

        // this.data = res.data.records;
        this.data = res.data.records

      } else {
        this.$message.error("查询失败", function () { });
      }
    },



  }
};
</script>